import { create } from "sheetly";
export let text = "";
export const sheet = create(text, import.meta.url);
